import { gtc } from '../assets/js/main.js'

var jsSHA = require('jssha')

export const dataLayer = {
	methods: {
		$_dataLayer_dataLayerActivate () {
			setTimeout(function () {
				gtc({
					'event': 'optimize.activate'
				})
			}, 0)
		},
		$_dataLayer_dataLayerLastStep () {
      return;
			var self = this

			gtc({
				'event': 'CHECKOUT_LAST_STEP',
				'new': true,
				'channel': 'new',
				'user': self.user,
				'order': self.orderStore.order
			})
		},

		$_dataLayer_dataLayerPlanSelected () {
      return;
			var self = this
			gtc({
				'event': 'CHECKOUT_ORDER_PLAN_SELECTED',
				'new': true,
				'channel': 'new',
				'user': self.user,
				'order': self.orderStore.order
			})
		},

		$_dataLayer_dataLayerTYNew () {
      return;
			var self = this

			gtc({
				'event': 'CHECKOUT_ORDER_CONFIRM_NEW',
				'new': true,
				'channel': 'new',
				'user': self.user,
				'order': self.user.order
			})
		},

		$_dataLayer_dataLayerTYRecurring () {
      return;
			var self = this

			gtc({
				'event': 'CHECKOUT_ORDER_CONFIRM_v2',
				'new': false,
				'channel': 'main',
				'user': self.user,
				'order': self.user.order
			})
		},

		$_dataLayer_newsletterSubscribed (email) {
      return;
			var shaObj = new jsSHA('SHA-1', 'TEXT')
			shaObj.update(email)
			var hash = shaObj.getHash('HEX')

			gtc({
				'event': 'NEWSLETTER_SUBSCRIBED',
				'url': window.location.href,
				'emailHash': hash
			})
		},

		$_dataLayer_dataLayerRecipeShare (params) {
      return;
			gtc({
				'event': 'RECIPE_SHARED',
				'recipe_id': params.recipeId,
				'recipe_name': params.recipeName,
				'social': params.social
			})
		}
	}
}
